import React from "react";
import { Pressable, ScrollView, StyleSheet, Text } from "react-native";

export default function ReportCategoryTabs({ tabs = [], selectedKey, onSelect }) {
  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={styles.container}
    >
      {tabs.map(({ key, label, Icon }) => {
        const selected = key === selectedKey;

        return (
          <Pressable
            key={key}
            accessibilityRole="tab"
            accessibilityState={{ selected }}
            onPress={() => onSelect(key)}
            style={[styles.tab, selected && styles.selectedTab]}
          >
            <Icon width={18} height={18} customColor={selected ? "#FFFFFF" : "#151515"} />
            <Text style={[styles.label, selected && styles.selectedLabel]} numberOfLines={1}>
              {label}
            </Text>
          </Pressable>
        );
      })}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: { flexDirection: "row", gap: 8, paddingRight: 2 },
  tab: { minHeight: 48, paddingHorizontal: 18, borderWidth: 1, borderColor: "#EEEEEE", borderRadius: 16, backgroundColor: "#FFFFFF", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: 8, elevation: 1, shadowColor: "#000000", shadowOpacity: 0.08, shadowRadius: 3, shadowOffset: { width: 0, height: 1 } },
  selectedTab: { borderColor: "#000000", backgroundColor: "#000000", elevation: 3, shadowOpacity: 0.18, shadowRadius: 4, shadowOffset: { width: 0, height: 2 } },
  label: { flexShrink: 1, color: "#151515", fontFamily: "Archivo-Regular", fontSize: 12 },
  selectedLabel: { color: "#FFFFFF", fontFamily: "Archivo-Regular" },
});